import type { TradeSelectorVariant } from "./types";

type MakeTradesUrlParams = {
  site: string;
  vertical: string;
  query: string;
  tradesEndpoint: string;
  variant: TradeSelectorVariant;
  searchScope?: string;
  primaryDetail?: boolean;
};

export function makeTradesUrl({
  site,
  vertical,
  query,
  tradesEndpoint,
  variant,
  searchScope,
  primaryDetail = false,
}: MakeTradesUrlParams): string {
  // Support both absolute and relative URLs
  // For relative URLs, use window.location.origin as base (SSR-safe)
  const isRelative = !tradesEndpoint.match(/^https?:\/\//);
  const baseUrl =
    isRelative && typeof window !== "undefined"
      ? window.location.origin
      : undefined;
  const url = new URL(tradesEndpoint, baseUrl);

  url.searchParams.append("service_channel_identifier", site);
  url.searchParams.append("vertical", vertical);
  url.searchParams.append("show_trade_definitions", "true");

  if (searchScope) {
    url.searchParams.append("search_scope", searchScope);
  }

  // if primaryDetail is false don't append since ruby will interpret any string value as true
  if (primaryDetail) {
    url.searchParams.append("primary_detail", "true");
  }

  const usesShortParam =
    tradesEndpoint.toLowerCase().includes("rambdas") ||
    tradesEndpoint.includes("/trade_search");

  // Use 'q' for rambdas endpoints and local /trade_search, 'query' for others
  url.searchParams.append(usesShortParam ? "q" : "query", query);

  if (variant === "ai") {
    url.searchParams.append("ai_results", "true");
    url.searchParams.append("ai_strategy", "rag-strategy");
  }

  return url.toString();
}
